import actionTypes from './actionTypes';

const initialState = {
  data: null,
  isFetching: false,
  masterWaybill: {},
  isCreatingMW: false,
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.START:
      return {
        ...state,
        isFetching: true,
        data: null,
      };

    case actionTypes.STARTING:
      return {
        ...state,
        isFetching: true,
      };

    case actionTypes.STARTED:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
      };

    case actionTypes.CREATE_MW:
      return {
        ...state,
        isCreatingMW: true,
        masterWaybill: {},
      };

    case actionTypes.CREATING_MW:
      return {
        ...state,
        isCreatingMW: true,
      };

    case actionTypes.CREATED_MW:
      return {
        ...state,
        isCreatingMW: false,
        masterWaybill: action.payload.data,
      };

    case actionTypes.FAILED_TO_CREATE_MW:
      return {
        ...state,
        isCreatingMW: false,
        masterWaybill: {},
      };

    default:
      return state;
  }
};

export default reducer;
